import {createContext, Dispatch} from 'react';

type initialStateType = {
    _id:string,
    idUser:number
    typeEval:string,
    typeArray:string,
    reload:boolean,
    modalPerformanceEvaluation:boolean,
    modalEliminaPerformanceEvaluation:boolean
    modalCompetenceEvaluation: boolean,
    eliminaCompetencePerformanceEvaluation: boolean
    modalEvaluationModel: boolean
    eliminaModelEvaluation: boolean
    modalCollaboratorPerformanceEvaluation: boolean
    modalCollaboratorExternoPerformanceEvaluation: boolean
    modalCollaboratorAddPerformanceEvaluation: boolean
    infoEvalExt:any,
    item:any
}

type ModalPartial = {
    state:initialStateType,
    dispatch: Dispatch<any>
}

export const initialState = {
    _id: '',
    typeEval:'',
    idUser:0,
    typeArray:'',
    reload:false,
    modalPerformanceEvaluation: false,
    modalCompetenceEvaluation: false,
    modalEliminaPerformanceEvaluation:false,
    eliminaCompetencePerformanceEvaluation: false,
    modalEvaluationModel: false,
    eliminaModelEvaluation: false,
    modalCollaboratorPerformanceEvaluation:false,
    modalCollaboratorExternoPerformanceEvaluation:false,
    modalCollaboratorAddPerformanceEvaluation:false,
    infoEvalExt:null,
    item:null    
}

export enum Types {
    CREATE_PERFORMANCE_EVALUATION = "CREATE_PERFORMANCE_EVALUATION",    
    CLOSE_PERFORMANCE_EVALUATION = "CLOSE_PERFORMANCE_EVALUATION",
    DELETE_PERFORMANCE_EVALUATION = "DELETE_PERFORMANCE_EVALUATION",
    CLOSE_DELETE_PERFORMANCE_EVALUATION="CLOSE_DELETE_PERFORMANCE_EVALUATION",
    DELETE_COMPETENCE_EVALUATION = "DELETE_COMPETENCE_EVALUATION",
    CLOSE_DELETE_COMPETENVE_EVALUATION = "CLOSE_DELETE_COMPETENVE_EVALUATION",
    CREATE_COMPETENCE_EVALUATION = "CREATE_COMPETENCE_EVALUATION",
    CLOSE_COMPETENCE_EVALUATION = "CLOSE_COMPETENCE_EVALUATION",
    CREATE_EVALUATION_MODEL = "CREATE_EVALUATION_MODEL",
    CLOSE_EVALUATION_MODEL = "CLOSE_EVALUATION_MODEL",
    DELETE_EVALUATION_MODEL = "DELETE_EVALUATION_MODEL",
    CLOSE_DELETE_EVALUATION_MODEL = "CLOSE_DELETE_EVALUATION_MODEL",
    OPEN_COLLABORATOR_PERFORMANCE_EVALUATION  = "OPEN_COLLABORATOR_PERFORMANCE_EVALUATION",  
    CLOSE_COLLABORATOR_PERFORMANCE_EVALUATION = "CLOSE_COLLABORATOR_PERFORMANCE_EVALUATION",
    OPEN_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION  = "OPEN_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION",  
    CLOSE_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION = "CLOSE_COLLABORATOR_EXTERN_PERFORMANCE_EVALUATION",
    OPEN_COLLABORATOR_ADD_PERFORMANCE_EVALUATION  = "OPEN_COLLABORATOR_ADD_PERFORMANCE_EVALUATION",  
    CLOSE_COLLABORATOR_ADD_PERFORMANCE_EVALUATION = "CLOSE_COLLABORATOR_ADD_PERFORMANCE_EVALUATION"
}

const ModalInitialState = {
    state:initialState,
    dispatch:() => null
}

const PerformanceEvaluationContext = createContext<ModalPartial>(ModalInitialState)

export default PerformanceEvaluationContext; 
